import { createFeatureSelector, createSelector } from "@ngrx/store";
import {
  INCIDENT_FEATURE_KEY,
  IncidentState,
  IncidentPartialState,
  incidentAdapter,
} from "./incident.reducer";
import { IncidentDto } from "@cradua/data";

// Lookup the 'Incident' feature state managed by NgRx
export const getIncidentState = createFeatureSelector<
  IncidentPartialState,
  IncidentState
>(INCIDENT_FEATURE_KEY);

const {
  selectAll,
  selectEntities,
} = incidentAdapter.getSelectors();

export const getIncidentLoaded = createSelector(
  getIncidentState,
  (state: IncidentState) => state.loaded,
);

export const getIncidentError = createSelector(
    getIncidentState,
  (state: IncidentState) => state.error,
);

export const loadingIncident = createSelector(
    getIncidentState,
  (state: IncidentState) => state.loaded,
);

export const getAllIncident = createSelector(
    getIncidentState,
  (state: IncidentState) => selectAll(state),
);

export const getIncidentEntities = createSelector(
    getIncidentState,
  (state: IncidentState) => selectEntities(state),
);

export const getSelectedId = createSelector(
    getIncidentState,
  (state: IncidentState) =>
    state.selectedIncidentId,
);

export const getSelected = createSelector(
  getIncidentEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId],
);

export const getLastInsertedValue = createSelector(
  getAllIncident,
  (incidents: IncidentDto[]) => incidents[0],
);

export const getSearchIncidentRecord = createSelector(
  getAllIncident,
  getSelectedId,
  (incident: IncidentDto[], selectedId) => {
    if (selectedId === ".") {
      return incident;
    }

    return !selectedId ? null : incident.filter(
      (item) =>
        item.IncidentName.toLowerCase().includes(
          String(selectedId).toLowerCase(),
        ) ||
        item.IncidentName.toLowerCase().includes(
          String(selectedId).toLowerCase(),
        ) ||
        item.IncidentName.toLowerCase().includes(
          String(selectedId).toLowerCase(),
        ),
    );
  },
);

export const getSearchIncidentIdRecord = createSelector(
  getAllIncident,
  getSelectedId,
  (incident: IncidentDto[], selectedId) =>
    incident.find((item) => item.id === selectedId),
);



 